const merge = require('lodash/merge');
const config = require('./config.common');

module.exports = merge({}, config, {
  environment: 'prd',
  isPublisherActive: true,
  app: {
    protocol: 'https',
    host: 'prog.prd.prd.viooh.com.cn',
    port: null,
  },
  api: {
    BASE_URL: 'https://gateway-api.prod.viooh.com.cn/',
  },
  gatewayApi: {
    BASE_URL: 'https://gateway-api.prod.viooh.com.cn/',
  },
  keycloak: {
    url: 'https://keycloak.prod.viooh.com.cn/',
    realm: 'prd-cn',
    clientId: 'trading-manager-ui-front',
  },
  authProvider: 'Keycloak',
  dataDog: {
    sessionReplaySampleRate: 20,
  },
  thoughtspot: {
    host: 'https://viooh.thoughtspot.cloud/',
    identifier: 'production',
    dealHealthDashboardId: '1b6e0cc5-fbc1-4ec9-aa8d-b74d10c8fb16',
    resellerDealHealthDashboardId: '6d7a0736-ca77-4021-a156-74e8b1a1b1a0',
    dealManagementMetrics: '925409d9-c30f-4fe5-a94e-b56906980245',
    todaysRevenueVizId: 'd62f5caf-8141-4766-ba69-c91019d0e41c',
    monthToDateVizId: '6b2fa444-0b8d-4b88-a14c-706fe93a9811',
    chinaProofOfPlayLiveboardId: 'f0e26617-5acc-46e0-904e-753552a9207b',
    chinaDealHealthLiveboardId: '89f180f4-2864-42ee-89a6-0b576875ddd3',
    assetHealthLiveboardId: '30169e47-3b5e-48ef-8dac-16ae2b41075a',
    quickDeliveryStatsLiveboardId: '1b6e0cc5-fbc1-4ec9-aa8d-b74d10c8fb16',
    quickDeliveryStatsVisualizationId: 'e480bbb2-de4e-425d-8c06-11bbcc05c889',
  },
  features: (market) => ({
    ...config.features(market),
  }),
});
